
import _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { getExternalRecivers } from '../../../admin/actions'
import { getPractitioners } from '../../../Header/User/actions'
import {
  bindTargetMixin,
  CareTeamMemberSelectInput,
  PractitionerTelecomSelectInput,
  SaveButton
} from '../../../shared/FormBuilder'
import { shareReport } from '../actions'

class ReportForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)

    this.state = {
      value: {
        communicationMedium: this.props.communicationMedium
      },
      forceValidation: false,
      valid: false
    }

    this.props.dispatch(getPractitioners())
    this.props.dispatch(getExternalRecivers())

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit () {
    const {
      reportMeta: { patientId, reportType, reportId },
      communicationMedium
    } = this.props
    this.props.dispatch(
      shareReport(
        patientId,
        reportType,
        reportId,
        communicationMedium,
        this.state.value
      )
    )
  }

  UNSAFE_componentWillUpdate (nextProps, nextState) {
    if (this.state.value !== nextState.value) {
      if (nextState.value.recipient && nextState.value.contactValue) {
        return this.setState({ valid: true })
      }
      return this.setState({ valid: false })
    }
  }

  render () {
    const {
      reportMeta,
      communicationMedium,
      reports: { sharing },
      externalReceivers,
      clientName
    } = this.props

    const externalReceiversFiltered = (externalReceivers || []).filter(
      r =>
        _.get(r, `clients.${clientName}`, false) &&
        _.get(r, communicationMedium)
    )

    const renderTelecom = () => {
      if (this.state.value.recipient) {
        return (
          <PractitionerTelecomSelectInput
            name='contactValue'
            label={_.capitalize(communicationMedium)}
            practitionerReference={this.state.value.recipient.reference}
            patientId={reportMeta.patientId}
            system={communicationMedium}
            externalReceivers={externalReceiversFiltered}
          />
        )
      }
    }

    return (
      <div>
        <div className='row bottom-xs'>
          <div className='col-md-5 col-xs-12'>
            <CareTeamMemberSelectInput
              name='recipient'
              label='Recipient'
              patientId={reportMeta.patientId}
              externalReceivers={externalReceiversFiltered}
            />
          </div>
          <div className='col-md-5 col-xs-12'>{renderTelecom()}</div>
          <div className='col-md-2 col-xs-12'>
            <SaveButton
              formKey={this.props.formKey}
              style={{ marginTop: '25px' }}
              label='Send'
              disabled={!this.state.valid || sharing}
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    )
  }
}

ReportForm.propTypes = {
  reportMeta: PropTypes.shape({
    patientId: PropTypes.string,
    reportType: PropTypes.string,
    reportId: PropTypes.string
  }),
  communicationMedium: PropTypes.oneOf([ 'email', 'fax' ]).isRequired
}

const mapStateToProps = redux => ({
  reports: redux.reports,
  externalReceivers: redux.admin.externalReceivers,
  clientName: redux.globalVars.params.clientName
})

export default connect(mapStateToProps)(ReportForm)
